<!--
 * @Author: wxy
 * @Date: 2022-10-21 09:24:57
 * @LastEditTime: 2022-10-29 15:43:14
 * @Description: 供应商管理
-->
<template>
  <div class="supplierManagement">
    <ds-header title="供应商管理"></ds-header>
    <a-form layout="inline">
      <a-form-item label="供应商名称">
        <a-input v-model.trim="searchForm.supplierName" placeholder="请输入供应商名称查询"></a-input>
      </a-form-item>
      <a-form-item label="供应商适用项目">
        <!-- <a-select
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          style="width: 200px"
          placeholder="请选择供应商适用项目"
          v-model="searchForm.projectId"
        >
          <a-select-option value=""> 全部项目 </a-select-option>
          <a-select-option v-for="item in projectName" :key="item.projectId" :value="item.projectId">
            {{ item.projectName }}
          </a-select-option>
        </a-select> -->
        <!-- <el-cascader v-model="searchForm.projectId" style="width: 200px"
              :options="projectName"
              :props="{emitPath:false,checkStrictly: true , label: 'project_name', children: 'child', value: 'id' }" size="small"
              clearable></el-cascader> -->
          <a-cascader expandTrigger="hover" style="width: 100%;" v-model="searchForm.projectId"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode" :options="projectName"
          :fieldNames="{ label: 'project_name', children: 'child', value: 'id' }"
          placeholder="请选择供应商适用项目" />
      </a-form-item>
      <a-form-item label="状态">
        <a-select
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          style="width: 200px"
          placeholder="请选择状态"
          v-model="searchForm.supplierState"
        >
          <a-select-option value="">全部状态</a-select-option>
          <a-select-option v-for="item in status" :key="item.value" :value="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <span>
        <a-button type="primary" @click="search" style="margin-top: 3px" icon="search"> 查询 </a-button>
        <a-button style="margin-left: 15px" @click="resetSearchForm" icon="redo">重置</a-button>
      </span>
    </a-form>
    <div style="margin: 10px 0">
      <a-button type="primary" @click="add"> <a-icon type="plus" /> 新增供应商</a-button>
    </div>
    <a-table
      :rowKey="(record, index) => index"
      :columns="table.columns"
      :data-source="table.tableData"
      :pagination="table.pagination.total ? table.pagination : false"
      @change="pageChange"
      bordered
      :scroll="{ x: 1500 }"
    >
      <span slot="titles" slot-scope="text, record">合计:{{ record }}</span>
      <div slot="projectName" slot-scope="text">
        <a-tooltip>
          <template slot="title">
            <span>{{ text.projectNames }}</span>
          </template>
          <div
            :style="{
              width: '100%',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            }"
          >
            {{ text.projectNames }}
          </div>
        </a-tooltip>
      </div>
      <div slot="supplierName" slot-scope="text">
        <a-tooltip>
          <template slot="title">
            <span>{{ text }}</span>
          </template>
          <div
            :style="{
              width: '100%',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            }"
          >
            {{ text }}
          </div>
        </a-tooltip>
      </div>
      <div slot="supplerLabel" slot-scope="text">
        <a-tooltip>
          <template slot="title">
            <span>{{ text.supplerLabel }}</span>
          </template>
          <div
            :style="{
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            }"
          >
            {{ text.supplerLabel? text.supplerLabel : "-" }}
          </div>
        </a-tooltip>
      </div>
      <span slot="action" slot-scope="text, record" class="action">
        <a-button type="link" @click="isEnabled(record)" class="btn"
          >{{ record.supplerState === 0 ? "禁用" : "启用" }}
        </a-button>
        <a-button type="link" @click="toDetail(record)" class="btn"> 查看 </a-button>
        <a-button type="link" @click="edit(record)" class="btn"> 编辑 </a-button>
        <a-button type="link" @click="deleteSupplier(record)" style="color: #f5222d" class="btn"> 删除 </a-button>
      </span>
    </a-table>
  </div>
</template>

<script>
import pageRules from "@/utils/pagingConfig/pageUtils.js";
import * as api from "@/api/entrepreneurClubManagement/serverManagement";
export default {
  name: "supplierManagement",
  data() {
    return {
      // 搜索条件
      searchForm: {
        // 供应商名称
        supplierName: '',
        // 适用项目
        projectId: [],
        //状态
        supplierState: "",
      },
      // 适用项目
      projectName: [],

      // 表格
      table: {
        columns: [
          {
            title: "供应商名称",
            dataIndex: "supplierName",
            key: "supplierName",
            scopedSlots: { customRender: "supplierName" },
            width: 150,
          },
          {
            title: "供应商适用项目",
            key: "projectNames",
            width: 220,
            scopedSlots: { customRender: "projectName" },
          },
          {
            title: "供应商分类",
            key: "supplerLabel",
            width: 220,
            scopedSlots: { customRender: "supplerLabel" },
          },

          {
            title: "创建人",
            dataIndex: "createName",
            key: "createName",
            width: 120,
          },
          {
            title: "创建时间",
            dataIndex: "gmtCreate",
            key: "gmtCreate",
            width: 180,
          },
          {
            title: "最后修改人",
            dataIndex: "modifiedName",
            key: "modifiedName",
            width: 120,
          },
          {
            title: "最后修改时间",
            dataIndex: "gmtModified",
            key: "gmtModified",
            width: 180,
          },
          {
            title: "状态",
            dataIndex: "supplerState",
            key: "supplerState",
            width: 120,
            customRender(text) {
              return text == 0 ? "已启用" : "已禁用";
            },
          },
          {
            title: "操作",
            key: "action",
            width: "200px",
            className: "action-ql-list",
            scopedSlots: { customRender: "action" },
            fixed:"right",
          },
        ],
        tableData: [],
        pagination: {
          pageSizeOptions: ["10", "20", "30", "50", "100"],
          showSizeChanger: true,
          current: 1,
          pageSize: 10,
          total: 0,
          showQuickJumper: true,
          showTotal: (total) => {
            return `共 ${total} 条`;
          },
        },
      },
      // 状态
      status: [
        {
          value: 0,
          label: "已启用",
        },
        {
          value: 1,
          label: "已禁用",
        },
      ],
    };
  },
  // 进入路由添加缓存
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$store.dispatch("operationCachedRoutes/updateAliveRoutes", ["supplierManagement"]);
    });
  },
  // 离开清除缓存
  beforeRouteLeave(to, from, next) {
    if (to.path !== "/entrepreneurClubManagement/serverManagement/supplierManagement/detail") {
      this.$store.dispatch("operationCachedRoutes/updateAliveRoutes", []);
    }
    next();
  },
  mounted() {
    // 获取列表数据
    this.getList();
    // 获取项目
    this.getProject();
    let handleResize = ()=> {
      let width = document.getElementsByClassName('supplierManagement')[0].clientWidth;
      console.log(width,'=====');
      if(width>1510){
        this.table.columns[this.table.columns.length-1].fixed = '';
      }else{
        this.table.columns[this.table.columns.length-1].fixed = 'right';
      }
    }
    window.addEventListener('resize', handleResize);
    handleResize()
  },
  methods: {
    // 搜索
    search() {
      this.table.pagination.current = 1;
      this.table.pagination.pageSize = 10;
      this.getList();
    },
    // 重置
    resetSearchForm() {
      this.searchForm = {
        // 供应商名称
        supplierName: '',
        // 适用项目
        projectId: [],
        // 状态
        supplierState: "",
      };
      this.table.pagination.current = 1;
      this.table.pagination.pageSize = 10;
      this.getList();
    },
    // 获取数据
    async getList() {
      try {
        const data = {
          page: this.table.pagination.current,
          size: this.table.pagination.pageSize,
          ...this.searchForm,
          projectId:this.searchForm.projectId.length?this.searchForm.projectId[this.searchForm.projectId.length-1]:''
        };
        const res = await api.getSupplierList(data);
        if (res.code === "200") {
          this.table.tableData = res.data.supplierInfos;
          this.table.pagination.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {}
    },
    // 切换分页
    pageChange(option) {
      this.table.pagination.current = option.current;
      this.table.pagination.pageSize = option.pageSize;
      this.getList();
    },
    // 添加供应商
    add() {
      this.$router.push({
        path: "/entrepreneurClubManagement/serverManagement/supplierManagement/add",
        query: {
          type: "add",
        },
      });
    },
    // 编辑
    edit(record) {
      this.$router.push({
        path: "/entrepreneurClubManagement/serverManagement/supplierManagement/add",
        query: {
          type: "edit",
          id: record.supplierId,
        },
      });
    },
    // 查看
    toDetail(record) {
      this.$router.push({
        path: "/entrepreneurClubManagement/serverManagement/supplierManagement/detail",
        query: {
          id: record.supplierId,
        },
      });
    },
    // 删除
    deleteSupplier(record) {
      const _this = this;
      _this.$confirm({
        title: "确认删除",
        content: "删除后该数据无法恢复，确认删除吗？",
        async onOk() {
          try {
            const res = await api.deleteSupplier(record.supplierId);
            if (res.code === "200") {
              _this.table.pagination.current = pageRules.pageRules(
                _this.table.tableData.length,
                1,
                _this.table.pagination.current
              );
              _this.$message.success("删除成功!");
              _this.getList();
            } else {
              _this.$message.error(res.msg);
            }
          } catch (error) {
            _this.$message.error("删除失败");
          }
        },
        onCancel() {},
      });
    },
    // 禁用/启用
    isEnabled(record) {
      const _this = this;
      let title;
      let content;
      let supplerState = 0;
      if (record.supplerState === 1) {
        title = "确认启用该供应商";
        content = "";
        supplerState = 0;
      } else {
        title = "确认禁用该供应商";
        content = "";
        supplerState = 1;
      }
      _this.$confirm({
        title: title,
        content: content,
        async onOk() {
          try {
            const res = await api.enableSupplier({ supplierId: record.supplierId, supplerState: supplerState });
            if (res.code === "200") {
              _this.$message.success("操作成功");
              _this.getList();
            } else {
              _this.$message.error(res.msg);
            }
          } catch (error) {}
        },
        onCancel() {},
      });
    },
    // 获取所属项目
    async getProject() {
      try {
        const res = await api.getShunyiAllProject();
        if (res.code === "200") {
          this.projectName = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {}
    },
  },
};
</script>

<style lang='scss' scoped>
.btn {
  padding: 4px;
}
</style>